import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "4",
      cy: "12",
      r: "3",
      class: "spinner1"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "3",
      class: "spinner1 spinner2"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "20",
      cy: "12",
      r: "3",
      class: "spinner1 spinner3"
    }, null, -1)
  ]))]))
}
export default { render: render }